/*
@GetMapping("/{tireSize}/ymm/{year}/{make}/{model}/BAC/{bac}/brand/{brand}")
public String getYMMTireSizeSummaryWithBrand(@PathVariable("year") String year,
@PathVariable("make") String make, @PathVariable("model") String model,
@PathVariable("tireSize") String tireSize, @PathVariable("bac") String bac,
@PathVariable("brand") String brand) {
    logger.info("**********getYMMTireSizeSummaryWithBrand**********");
    TireInfoDetails tireInfoDetails = TireInfoDetails.parseTireSize(tireSize);
    return tireInfoService.getTireInfoBySize(year, make, model, tireInfoDetails, bac, brand);
}

@GetMapping("/{tireSize}/ymm/{year}/{make}/{model}/BAC/{bac}")
public String getYMMTireSizeSummary(@PathVariable("year") String year,
@PathVariable("make") String make, @PathVariable("model") String model,
@PathVariable("tireSize") String tireSize, @PathVariable("bac") String bac) {
    logger.info("**********TireFInderRest getYMMTireSizeSummary**********");
    logger.info("**********Tire Size: " + tireSize + "************");
    TireInfoDetails tireInfoDetails = TireInfoDetails.parseTireSize(tireSize);
    return tireInfoService.getTireInfoBySize(year, make, model, tireInfoDetails, bac, null);
}*/

import rest from "../axiosRestCalls";
import store from "../../core/redux/Store";
import {API_BASE_PATH} from "../restConstants";
import {setAxiosCancelSource, setSearchResult, setSpinner} from "../../core/redux/ActionCreator";
import axios from "axios";

const API = API_BASE_PATH;

class searchResultsService {
    getResults(size, year, make, model, bac) {
        store.dispatch(setSpinner({spinner: true}));
        const source = store.getState().searchResultReducer.axiosCancelSource;
        let parsedSize = size.replace("/", "_");

        if (source) {
            source.cancel('Cancelling previous request')
        }

        const CancelToken = axios.CancelToken;
        const localSource = CancelToken.source();

        rest.get(API + "tireSize/" + parsedSize + "/ymm/" + year + "/" + make
            + "/" + model.replaceAll('/', '_') + "/BAC/" + bac, {cancelToken: localSource.token}).then((res) => {
            if (Object.keys(res.data).length > 0) {
                store.dispatch(setSearchResult(res.data));
            }
            store.dispatch(setSpinner({spinner: false}));
        }).catch((e) => {
            if (axios.isCancel(e)) {
                console.log('Request cancelled', e.message);
            }
        });
        store.dispatch(setAxiosCancelSource(localSource));
    }

    getResultsBrand(size, year, make, model, bac, brand) {
        store.dispatch(setSpinner({spinner:true}));
        let parsedSize = size.replace("/", "_");
        rest.get(API + "tireSize/" + parsedSize + "/ymm/" + year + "/" + make
            + "/" + model.replaceAll('/', '_') + "/BAC/" + bac + "/brand/" + brand).then((res) => {
            if (Object.keys(res.data).length > 0) {
                store.dispatch(setSearchResult(res.data));
            }
            store.dispatch(setSpinner({spinner:true}));
        });
    }
}
// eslint-disable-next-line
export default new searchResultsService();
